import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Image } from 'react-bootstrap';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Cart() {
    const normalizeCartItems = (items) => {
        return items.reduce((acc, item) => {
            const existingIndex = acc.findIndex(cartItem => cartItem.menuItemName === item.menuItemName);
            if (existingIndex > -1) {
                acc[existingIndex] = {
                    ...acc[existingIndex],
                    quantity: (acc[existingIndex].quantity || 1) + (item.quantity || 1),
                };
            } else {
                acc.push({ ...item, quantity: item.quantity || 1 });
            }
            return acc;
        }, []);
    };

    const [cartItems, setCartItems] = useState(() => {
        const saved = localStorage.getItem('cart_items');
        const items = saved ? JSON.parse(saved) : [];
        return normalizeCartItems(items);
    });
    const [promoInput, setPromoInput] = useState(() => {
        return localStorage.getItem('cart_applied_promo') || '';
    });
    const [appliedPromo, setAppliedPromo] = useState(() => {
        return localStorage.getItem('cart_applied_promo') || '';
    });
    const [promoError, setPromoError] = useState('');

    useEffect(() => {
        localStorage.setItem('cart_items', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('localStorageChange'));
    }, [cartItems]);

    useEffect(() => {
        localStorage.setItem('cart_applied_promo', appliedPromo);
    }, [appliedPromo]);

    useEffect(() => {
        const handleStorage = () => {
            const saved = localStorage.getItem('cart_items');
            const items = saved ? JSON.parse(saved) : [];
            setCartItems(normalizeCartItems(items));
        };
        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    const increment = (index) => {
        setCartItems((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? { ...item, quantity: (item.quantity || 1) + 1 } : item
            )
        );
    };
    const decrement = (index) => {
        setCartItems((prevItems) =>
            prevItems.map((item, i) =>
                i === index && (item.quantity || 1) > 1
                    ? { ...item, quantity: item.quantity - 1 }
                    : item
            )
        );
    };

    const removeItem = (index) => {
        setCartItems((prevItems) => prevItems.filter((_, i) => i !== index));
    };

    const handleApplyPromo = () => {
        if (promoInput.trim().toUpperCase() === 'FOOD50') {
            setAppliedPromo('FOOD50');
            setPromoError('');
        } else {
            setPromoError('Invalid promo code. Try "FOOD50".');
            setAppliedPromo('');
        }
    };

    const subtotal = cartItems.reduce((sum, item) => {
        const price = parseFloat((item.menuItemPrice || item.foodPrice || '').replace('$', '')) || 0;
        const quantity = item.quantity || 1;
        return sum + price * quantity;
    }, 0);

    const discount = appliedPromo === 'FOOD50' ? subtotal * 0.5 : 0.00;
    const grandTotal = Math.max(0, subtotal - discount);

    return (
        <>
            <PageSubTitle pagename="Cart" />
            <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='section'>
                <Container>
                    <Row>
                        <Col lg={7}>
                        <motion.div initial={{opacity: 0,x: -20}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.5}}>
                            <Card className='cart-table mb-lg-0 border'>
                                <Card.Body className='p-3'>
                                    <Table responsive className='mb-0 table-transparent'>
                                        <thead>
                                            <tr>
                                                <th className='h5'>Food List</th>
                                                <th className='text-end h5'>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cartItems.length === 0 ? (
                                                <tr>
                                                    <td colSpan={2} className='text-center py-5'>
                                                        <h5 className='fw-semibold text-muted'>Your cart is empty.</h5>
                                                    </td>
                                                </tr>
                                            ) : (
                                                cartItems.map((data, i) => {
                                                    const image = data.menuFoodImg || data.cartFoodImg;
                                                    const title = data.menuItemName || data.foodName;
                                                    const description = data.menuItemDesc || data.foodSubText;
                                                    const price = parseFloat((data.menuItemPrice || data.foodPrice || '').replace('$', '')) || 0;
                                                    const quantity = data.quantity || 1;
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                <div className="d-flex align-items-center cart-box">
                                                                    <div className="flex-shrink-0">
                                                                        <div className='bg-light border cart-food-img px-3 py-2 rounded-3'>
                                                                            <Image src={require(`../images/menu-item/${image}`)} alt="" className='cart-img png-img-shadow-sm' />
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex-grow-1 ms-4">
                                                                        <h4 className='mb-1 fs-24 fw-semibold'>{title}</h4>
                                                                        <p className='text-muted fs-18 mb-2'>{description}</p>
                                                                        <div className="qty-select">
                                                                            <span className="qty-btn cursor" onClick={() => decrement(i)} >
                                                                                <i className="ri-subtract-line"></i>
                                                                            </span>
                                                                            <span className="qty-value">
                                                                                {quantity}
                                                                            </span>
                                                                            <span className="qty-btn cursor" onClick={() => increment(i)}>
                                                                                <i className="ri-add-line"></i>
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className='text-end'>
                                                                <span className='avatar avatar-sm bg-soft-danger ms-auto text-danger rounded-3 cursor' onClick={() => removeItem(i)}>
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </span>
                                                                <h5 className='text-danger mt-5 fw-semibold mb-0'>
                                                                    ${(price * quantity).toFixed(2)}
                                                                </h5>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </motion.div>
                        </Col>

                        <Col lg={5}>
                            <motion.div initial={{opacity: 0,x: 20}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.5}} className="cart-summary-box">
                                <Card className='border'>
                                    <Card.Body>
                                        <h5 className='mb-3'>Order Summary</h5>
                                        <div className="d-flex justify-content-between mb-3">
                                            <h6 className='fw-normal fs-20 text-muted'>Subtotal</h6>
                                            <h6 className='fw-medium fs-20'>${subtotal.toFixed(2)}</h6>
                                        </div>
                                         <div className="mb-4">
                                             <Form.Label>Discount Code (FOOD50)</Form.Label>
                                             <InputGroup >
                                                 <Form.Control 
                                                     placeholder="Enter discount code..." 
                                                     value={promoInput}
                                                     onChange={(e) => setPromoInput(e.target.value)}
                                                 />
                                                 <Button 
                                                     variant="outline-secondary" 
                                                     id="button-addon2"
                                                     onClick={handleApplyPromo}
                                                 >
                                                     Apply
                                                 </Button>
                                             </InputGroup>
                                             {appliedPromo && (
                                                 <Form.Text className="text-success d-block mt-1">
                                                     Promo code '{appliedPromo}' applied successfully! (50% Off)
                                                 </Form.Text>
                                             )}
                                             {promoError && (
                                                 <Form.Text className="text-danger d-block mt-1">
                                                     {promoError}
                                                 </Form.Text>
                                             )}
                                         </div>
                                         <div className="d-flex justify-content-between mb-3">
                                             <h6 className='fw-normal fs-20 text-muted'>Discount</h6>
                                             <h6 className='fw-medium text-muted fs-20'>- ${discount.toFixed(2)}</h6>
                                         </div>
                                        <hr />
                                        <div className="d-flex justify-content-between">
                                            <h5 className='fw-semibold mb-0'>Grand Total</h5>
                                            <h5 className='fw-semibold mb-0'>${grandTotal.toFixed(2)}</h5>
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Link to="/checkout" className='btn btn-danger w-100'>Checkout</Link>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
